import styles from '../causeProfile/ProfilePage.module.scss'

import { Loader, TitleCard } from '@percent/cause-dashboard/common/components'
import { useQuery } from '@percent/cause-dashboard/common/hooks'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'
import { useTranslation } from 'react-i18next'
import { MyAccountForm } from './MyAccountForm/MyAccountForm'
import CommPreferencesCard from './CommunicationPreferences/CommPreferencesCard'
import TwoFA from './TwoFA/TwoFACard'
import { Grid } from '@percent/lemonade'
import { useBreadcrumbs } from '../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'

export function MyAccountContainer() {
  const { t } = useTranslation()
  useBreadcrumbs([{ label: t('breadcrumb.myAccount') }])

  const { accountService } = useServices()
  const [{ data, isLoading }, { refresh }] = useQuery(accountService.getAccount, {})

  const fullName = data?.fullName
  const phoneNumber = data?.phoneNumber
  const preferredName = data?.preferredName

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      <Grid gutter={32} className={styles.profilePageGrid}>
        <TitleCard title={t('card.myAccount')}>
          <MyAccountForm name={fullName} number={phoneNumber} handle={preferredName} refresh={refresh} />
        </TitleCard>
      </Grid>
      <Grid gutter={32} className={styles.profilePageGrid}>
        <TitleCard title={t('typography.2faOption')}>
          <TwoFA />
        </TitleCard>
      </Grid>
      <Grid gutter={32} className={styles.profilePageGrid}>
        <TitleCard title={t('typography.communicationPreferences')}>
          <CommPreferencesCard />
        </TitleCard>
      </Grid>
    </>
  )
}
